import { connect } from 'react-redux';
import { VODCSSModules } from 'shared/utils/wix-connect';

import classnames from 'classnames';

import { areElementsRounded } from 'shared/selectors/app-settings';
import socialNetworkNames from 'widget/constants/social-networks';

import SocialButton from './social-button/social-button';

import styles from './social-share.styl';


@connect(state => ({
  areElementsRounded: areElementsRounded(state),
}))
@VODCSSModules(styles)
export default class SocialShare extends React.Component {

  static propTypes = {
    areElementsRounded: React.PropTypes.bool,
    networks: React.PropTypes.arrayOf(React.PropTypes.string),
    content: React.PropTypes.shape({
      siteUrl: React.PropTypes.string,
      title: React.PropTypes.string,
      description: React.PropTypes.string,
      thumbnailUrl: React.PropTypes.string,
    }),
    className: React.PropTypes.string,
    buttonClassName: React.PropTypes.string,
    linkClassName: React.PropTypes.string,
    popoutOuterClassName: React.PropTypes.string,
    popoutInnerClassName: React.PropTypes.string,
    networksClassNames: React.PropTypes.object,
    onShare: React.PropTypes.func,
  };

  static defaultProps = {
    networks: _.values(socialNetworkNames),
    networksClassNames: {},
    onShare: _.noop,
  };

  render() {
    const {
      areElementsRounded,
      networks,
      content,
      className,
      popoutOuterClassName,
      popoutInnerClassName,
      buttonClassName,
      networksClassNames,
      linkClassName,
      onShare,
    } = this.props;

    return (
      <div styleName="social-share"
           className={className}>
        {
          _.map(networks, network => (
            <SocialButton styleName="social-button"
                          popoutOuterClassName={popoutOuterClassName}
                          popoutInnerClassName={popoutInnerClassName}
                          className={classnames(buttonClassName, networksClassNames[network])}
                          rounded={areElementsRounded}
                          key={network}
                          network={network}
                          content={content}
                          linkClassName={linkClassName}
                          onClick={onShare} />
          ))
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/social-share/social-share.js